var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteUserOptionDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "favouriteUserOptionDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.4574591,148.854398 C62.9495438,148.374828 63.1232502,147.670992 62.910998,147.016715 C62.6982452,146.362437 62.1440867,145.895382 61.4632777,145.796264 L55.4100847,144.916719 C55.1522783,144.879175 54.9295136,144.717482 54.8143768,144.483705 L52.108161,138.999187 C51.8042999,138.382955 51.187567,138 50.5002503,138 C49.8134342,138 49.1967013,138.382955 48.8928402,138.999187 L46.1861238,144.484205 C46.070987,144.717983 45.8477217,144.879675 45.5899153,144.91722 L39.5367223,145.796765 C38.8564139,145.895382 38.3017548,146.362938 38.089002,147.017215 C37.8767498,147.671493 38.0504562,148.375329 38.5425409,148.854899 L42.9222453,153.123972 C43.1089672,153.306188 43.194569,153.5685 43.1505166,153.824805 L42.1172888,159.852968 C42.02568,160.383598 42.1648453,160.899712 42.5082534,161.306695 C43.0418875,161.940949 43.9734945,162.134179 44.7183797,161.742713 L50.1318125,158.896331 C50.3580814,158.77769 50.6429198,158.778691 50.8686881,158.896331 L56.2826215,161.742713 C56.5459344,161.881378 56.8267681,161.951462 57.1166125,161.951462 C57.6457413,161.951462 58.1473373,161.716182 58.4922472,161.306695 C58.8361559,160.899712 58.9748206,160.382597 58.8832118,159.852968 L57.8494834,153.824805 C57.805431,153.567999 57.8910328,153.306188 58.0777547,153.123972 L62.4574591,148.854398 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-5-Dropdown---After-interaction",
    transform: "translate(-695.000000, -386.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-popUp",
    transform: "translate(658.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PopUpMenu"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "favouriteUserOptionDesktop",
    stroke: "#646464",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteUserOptionDesktop);
export default __webpack_public_path__ + "static/media/favouriteUserOptionDesktop.f2cab3efd7ab49078761a42fe617931d.svg";
export { ForwardRef as ReactComponent };